export const CalculateMonthlyPaymentModalTestIds = {
  ESTIMATION_RADIO: 'calculate-monthly-payment.estimation-radio',
  PERCENT_INPUT: 'calculate-monthly-payment.percent-input',
  MONTHS_INPUT: 'calculate-monthly-payment.months-input',
  CANCEL_BUTTON: 'calculate-monthly-payment.cancel-button',
  SAVE_BUTTON: 'calculate-monthly-payment.save-button',
};
